import React from 'react';
import {connect} from 'react-redux';
import {getCellBgColor} from 'helpers/common-helper';
import PlayersInfo from 'desktop/elements/players/info';
import {BasePlayersList} from 'components/organisms/players-list';
import PlayerLock from 'components/molecules/player-lock';
import PlayerExclusionState from 'components/molecules/player-exclusion/player-exclusion-state';
import Loader from 'components/atoms/loaders/loader';

class PlayersList extends BasePlayersList {
    constructor(props) {
        super(props);
        this.state = this.getBaseState({
            sortBy: {
                col: 'rosterPosition',
                direction: 'asc',
            },
        });
    }

    componentDidUpdate(prevProps) {
        const {
            userPointsType,
            reset: {settings: resetSettings},
        } = this.props;
        const {userPointsType: prevUPType} = prevProps;

        if (this.wasSettingsReset(resetSettings)) {
            this.updateResetSettingsSignature(resetSettings);
            super.resetBaseState({
                sortBy: {
                    col: 'rosterPosition',
                    direction: 'asc',
                },
            });
        } else if (!userPointsType.isUserPointsTypeEqual(prevUPType.getUserPointsType())) {
            super.resetBaseState({
                sortBy: {...this.state.sortBy},
            });
        }
    }

    getSearchConditions() {
        const {playersFilter} = this.props;
        let ruleByTiers = {};
        if (this.isNotExcludedMode(playersFilter.playersType)) {
            ruleByTiers = this.getSearchRuleByTiers();
        }

        return {
            ...this.getSearchRuleByMode({
                overallMode: {
                    checkPointsExclusion: true,
                    checkSalaryExclusion: true,
                },
            }),
            ...this.getSearchRuleByPlayerName(),
            ...ruleByTiers,
        };
    }

    render() {
        const {players, sportConfig, playersFilter} = this.props;

        if (!players.isPlayersGroupReady()) {
            return <Loader />;
        }

        const playersList = this.getPlayersForRendering();
        const renderKey = this.getRenderKey();

        const rows = [];
        if (playersList.length > 0) {
            let shadingOptions = sportConfig.getShadingOptions();
            playersList.map((player, index) => {
                let pointsBgColor = getCellBgColor(player.points, shadingOptions.points);
                let gradesBgColor = getCellBgColor(player.grades, shadingOptions.grades);

                rows.push(
                    <tr key={index}>
                        <td className="td-chk">
                            <PlayerExclusionState activeMode={playersFilter.playersType} playerId={player.getId()} />
                        </td>
                        <td className="td-lock">
                            <PlayerLock className={`lock-btn`} playerId={player.getId()} />
                        </td>
                        <td>
                            <span>{player.name}</span>
                        </td>
                        <td>{this.getPlayerSympathyComponent({player})}</td>
                        <td className={`tier tier-${player.rosterPositionName}`}>
                            <span>{player.rosterPositionName}</span>
                        </td>
                        <td className="color-cell" style={{...pointsBgColor}}>
                            <span>{player.points}</span>
                        </td>
                        <td>
                            <span>{player.projOwn.getValue()}</span>
                        </td>
                        <td className="color-cell" style={{...gradesBgColor}}>
                            <span>{player.grades}</span>
                        </td>
                        <td>
                            <span>{player.adminPoints}</span>
                        </td>
                        {this.getFinalPointsBlock({
                            points: player.fantasyPoints,
                        })}
                        <td className="td-narrow">
                            {this.wrapContentInTooltip(
                                this.getPlayerPointsComponent({
                                    player,
                                }),
                                `Default Score: ${player.adminPoints}`,
                            )}
                        </td>
                        <td className="td-narrow">
                            {this.getPlayerExposureComponent({
                                playerId: player.getId(),
                                propName: 'exposureMin',
                            })}
                        </td>
                        <td className="td-narrow">
                            {this.getPlayerExposureComponent({
                                playerId: player.getId(),
                                propName: 'exposureMax',
                            })}
                        </td>
                    </tr>,
                );
            });
        } else {
            rows.push(
                <tr key="players-not-found">
                    <td colSpan="13" className="text-center">
                        Players were not found.
                    </td>
                </tr>,
            );
        }

        return (
            <div>
                <div className="main-table table-holder table-scroll">
                    <table className="table players-pool">
                        <thead>
                            <tr>
                                <th className="td-chk">
                                    {this.getPlayersGroupExclusionSwitcherComponent(playersList)}
                                </th>
                                <th colSpan="3">
                                    <a
                                        className={super.getSortDirectionClassName('name')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'name')}
                                    >
                                        Name
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('rosterPosition')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'rosterPosition')}
                                    >
                                        Tier
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('points')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'points')}
                                    >
                                        Odds
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('projected_ownership')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'projected_ownership')}
                                    >
                                        pOwn%
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('grades')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'grades')}
                                    >
                                        Rating
                                    </a>
                                </th>
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('adminPoints')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'adminPoints')}
                                    >
                                        Proj
                                    </a>
                                </th>
                                {this.getFinalPointsHeaderSort()}
                                <th>
                                    <a
                                        className={super.getSortDirectionClassName('userPoints')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'userPoints')}
                                    >
                                        FPts
                                    </a>
                                </th>
                                <th className="td-per">
                                    <a
                                        className={super.getSortDirectionClassName('exposureMin')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'exposureMin')}
                                    >
                                        Exp. min
                                    </a>
                                    {this.getGeneralExposureComponent({
                                        players: playersList,
                                        propName: 'exposureMin',
                                    })}
                                </th>
                                <th className="td-per">
                                    <a
                                        className={super.getSortDirectionClassName('exposureMax')}
                                        href="#"
                                        onClick={(e) => ::this.sortBy(e, 'exposureMax')}
                                    >
                                        Exp. max
                                    </a>
                                    {this.getGeneralExposureComponent({
                                        players: playersList,
                                        propName: 'exposureMax',
                                    })}
                                </th>
                            </tr>
                        </thead>

                        <tbody>{rows}</tbody>
                    </table>
                </div>

                <PlayersInfo playersQuantity={playersList.length} />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {sportConfig, reset, playersLock, userPointsType, modesConfig} = state;
    const {players, filters: playersFilter, tiersFilter} = state.playersData;
    return {
        players,
        playersFilter,
        playersLock,
        sportConfig,
        tiersFilter,
        reset,
        userPointsType,
        modesConfig,
    };
}

let Table = connect(mapStatesToProps)(PlayersList);

export {Table};
